module.exports = __webpack_public_path__ + "img/JO.9f8039bd.svg";